import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FAWrapper from "components/vendors/fa-wrapper";
import Axios from "utils/axios";
import { Carousel, CarouselItem, Col, Container, Row } from "reactstrap";
import { CarousalItemOption } from "utils/carousal-items";
import { PartnerIcons } from "utils/partners-carousal-items";
import Slider from "components/slider";

const MktHero = (props) => {
  const { type, className = "" } = props;
  const [bgUrl, setBgUrl] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [partnerIndex, setPartnerIndex] = useState(0);
  const [partnerAnimating, setPartnerAnimating] = useState(false);

  useEffect(() => {
    getBannerVideoDetails();
  }, []);

  const getBannerVideoDetails = async () => {
    try {
      let axios = new Axios().instance();
      let response = await axios.get("/banner", null);

      setBgUrl(response?.data?.data?.[0]?.attributes?.photo);
    } catch (e) {
      throw toast.showError(e);
    }
  };

  const next = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === CarousalItemOption.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === 0 ? CarousalItemOption.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const slides = CarousalItemOption.map((item, index) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.desktop_src}
      >
        <picture>
          <source media="(max-width: 768px)" srcSet={item.mobile_src} />
          <img
            className="mkt-hero-content-image"
            src={item.desktop_src}
            alt={`Slide ${index + 1}`}
          />
        </picture>
      </CarouselItem>
    );
  });

  return (
    <header className={"mkt-hero-block" + " " + type + " " + className}>
      <Carousel
        className="mkt-hero-content-image"
        activeIndex={activeIndex}
        next={next}
        previous={previous}
        pause={false}
        interval={5000}
        ride="carousel"
      >
        {slides}
        <button
          disabled={activeIndex === CarousalItemOption?.length - 1}
          className="carousel-control-custom right"
          onClick={next}
        >
          <FAWrapper icon="chevron-right" />
        </button>
        <button
          disabled={activeIndex === 0}
          className="carousel-control-custom left"
          onClick={previous}
        >
          <FAWrapper icon="chevron-left" />
        </button>
      </Carousel>
      <div className="mkt-hero-content-container">
        <div className="mkt-hero-content-sub-container">
          <div className="mkt-hero-content">
            <h2 className="hero-headline">Luxury Hair & Makeup<br />Delivered to You</h2>
            <h5 className="hero-subheadline mt-3">
              Whether you're getting ready for a high-profile event, a
              photoshoot, or your next keynote — Blush Now brings expert beauty
              services directly to your door.
            </h5>
            <div>
              <Link to="/book" className="btn btn-primary btn-lg">
                Book Now
                <FAWrapper icon="chevron-right" className="sm ml-15" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="mkt-hero-partners-container">
        <div>
          <div className="partners-title">As Seen in</div>
        </div>
          <Slider items={PartnerIcons}/>
      </div>
    </header>
  );
};

export default MktHero;
